import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'dateTimeFormat',
     
})
export class DateTimeFormatPipe implements PipeTransform {
  transform(value, format: string = 'MM/DD/YYYY h:mm A'): any {
    if (!value) {
      return '';
    }
    if (moment.isMoment(value)) {
      return value.format(format);
    } else {
      throw new Error(
        'DateTimeFormatPipe expects input of moment object. Use the LocalMomentPipe or UtcMomentPipe first to create a moment object',
      );
    }
  }
}
